<template>
  <!-- 个人中心 -->
  <div class="personal">
    <div class="person-head">
      <div class="personal">
        <div class="avatar" v-if="userInfo">
          <i class="avatar-icon" :style="{ backgroundImage: 'url(' + userInfo?.HeadPhotoPath + ')' }"></i>
          <p>{{ userInfo.NickName }}</p>
          <div class="vip-info" v-if="vipInfo">
            {{ vipInfo.name }}
            <span v-if="vipInfo.deadline">{{ vipInfo.deadline }}到期</span>
            <span v-if="vipInfo.isPastdue">(已过期)</span>
          </div>
        </div>
      </div>
      <div class="person-menu">
        <div class="menu">
          <span :class="{ selected: currentType == item.type }" v-for="item in menuList"
            @click="currentType = item.type">{{ item.name }}</span>
        </div>
      </div>
    </div>
    <div class="person-content">
      <userInfo @refreshVIP="refreshVIP()" v-if="currentType == 'user-info'"></userInfo>
      <achievement_list v-if="currentType == 'achieve'"></achievement_list>
      <certificat_list v-if="currentType == 'certificat'"></certificat_list>
    </div>
    <foot></foot>
  </div>
</template>
<script>
import foot from "@/component/public/foot/foot.vue";
import userInfo from "@/component/personal/user-info/user-info.vue";
import achievement_list from "@/component/personal/achievement_list/achievement_list.vue";
import certificat_list from '@/component/personal/certificat_list/certificat_list.vue';
import moment from 'moment';

export default {
  components: {
    foot,
    userInfo,
    achievement_list,
    certificat_list
  },
  data() {
    return {
      userInfo: null,
      menuList: [
        { name: '信息', type: 'user-info' },
        { name: '徽章', type: 'achieve' },
        { name: '证书', type: 'certificat' }
      ],
      currentType: "user-info",
      vipInfo: null,
    };
  },
  async mounted() {
    let { userInfo, studentVip } = this.$store.state;
    if (!userInfo) return this.$router.push('/home');

    this.$store.commit('showReturn', true);

    this.userInfo = userInfo;
    this.studentVip = studentVip;
    this.findVip();
  },
  methods: {
    //找到vip
    findVip() {
      let vipInfo = this.studentVip.find(item => item.type == "vip_inner_training");
      if (vipInfo) {
        if (vipInfo.deadline && new Date() > new Date(vipInfo.deadline)) vipInfo.isPastdue = true;
        vipInfo.deadline = vipInfo.deadline ? moment(vipInfo.deadline).format('YYYY-MM-DD') : null;
        this.vipInfo = vipInfo;
      }
    },
    //刷新vip
    async refreshVIP() {
      let studentVip = await this.$api.payorder.getStudentVip(this.userInfo.PK_UserGuid).then(res => res.data || null);
      if (!studentVip) return;

      let content = studentVip.content ? JSON.parse(studentVip.content) : [];
      this.studentVip = content;

      this.findVip();
      this.$store.commit("studentVip", content);
    }
  }
}
</script>

<style scoped lang="scss">
@import "./personal.scss";
</style>